import React from 'react'

const OrderRecoveryBanner = () => (
  <p>
    Vuoi proseguire in un secondo momento? Controlla la casella di posta e
    assicurati di aver confermato il tuo indirizzo. Riceverai un’email di{' '}
    <em>Recupero ordine</em> che ti consentirà di concludere il processo entro
    14 giorni, salvo variazioni di disponibilità o di prezzo del veicolo.
  </p>
)

export default OrderRecoveryBanner
